import { render, staticRenderFns } from "./tabulate.vue?vue&type=template&id=cefc7b68&scoped=true&"
import script from "./tabulate.vue?vue&type=script&lang=js&"
export * from "./tabulate.vue?vue&type=script&lang=js&"
import style0 from "./tabulate.vue?vue&type=style&index=0&id=cefc7b68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefc7b68",
  null
  
)

export default component.exports